import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import * as PetApi from "../../api/apiPet";
import * as PhotosApi from "../../api/apiPhotos";
import Vaccines from './ficha/vaccine';
import VetHistory from './ficha/vetHistory';
import { useDispatch } from 'react-redux';
import { setPetData } from "../../redux/actions/petActions.js";

/**
 * MascotaDetails component
 * @description Componente que muestra los detalles de una mascota
 * @param {object} mascota - objeto con la información de la mascota
 * @module MascotaDetails
 */
const MascotaDetails = ({ mascota, userId, medicines}) => {
    // mascota del componente
    const [pet, setPet] = useState(null);
    // historial médico de la mascota
    const [medicalHistory, setMedicalHistory] = useState([]);
    // vacunas de la mascota
    const [vaccines, setVaccines] = useState([]);
    const [photo, setPhoto] = useState(null);
    const [editPhoto, setEditPhoto] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setPet(mascota);
        setPhoto(null);
        setEditPhoto(false);
        if (mascota === undefined || mascota === null) {
            return;
        }
        if (mascota.id) {
            getMedicalHistoryByPet(mascota.id);
            getVaccinesByPet(mascota.id);
        }
    }, [mascota]);

    useEffect(() => {
        ReactModal.setAppElement('body');
    }, []);

    const getVaccinesByPet = async (id) => {
        const response = await PetApi.getVaccinesByPet(id);
        setVaccines(response);
    }

    const getMedicalHistoryByPet = async (id) => {
        const response = await PetApi.getMedicalHistoryByPet(id);
        setMedicalHistory(response);
    }
    
    return (
        <section className='shadow'
            style={{
                textAlign: "center",
                width: "90%",
                maxWidth: 1000,
                margin: "50px auto",
                borderRadius: 20,
                minHeight: "70vh",
        }}>
            {(pet === null || pet?.id === "") &&
                <h2>Selecciona una mascota para ver sus detalles</h2>
            }
            {(pet !== null && pet?.id !== "") &&
            <div style={{
                backgroundColor: "white",
                borderRadius: 20,
                padding: 10,
            }}>
            <h2>Ficha de la mascota</h2>
            <div 
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                }}
            >
                <div>
                    <p>Nombre: {pet?.name}</p>
                    <p>Fecha de nacimiento: {pet?.birth}</p>
                    <p>Raza: {pet?.breed}</p>
                    <p>Peso: {pet?.weight} kg</p>
                </div>
                <div>
                    {!editPhoto ?
                    <div style={{ display: "flex", flexDirection: "column" }}>
                    <img src={pet?.photo} alt={pet?.name} style={{
                        width: 200,
                        height: 200,
                        borderRadius: "50%",
                    }} />
                    <button onClick={() => setEditPhoto(true)}
                        style={{
                            backgroundColor: "white",
                            cursor: "pointer",
                            border: "1px solid #ccc",
                            borderRadius: 20,
                            padding: 10,
                        }}
                    >Cambiar foto</button>
                    </div> :
                    <>
                    <form style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                        onSubmit={async (e) => {
                            e.preventDefault();
                            if (photo === null) {
                                return;
                            }
                            setLoading(true);
                            const res = await PhotosApi.uploadPetPhoto(pet.id, photo);
                            setLoading(false);
                            if (res) {
                                setEditPhoto(false);
                                setPhoto(null);
                                const pets = await PetApi.getPetsByOwner(userId);
                                dispatch(setPetData(pets));
                            }
                        }}
                    >
                        <img src={photo ? URL.createObjectURL(photo) : null} alt={"Previsualización de imagen"} style={{
                            width: 200,
                            height: 200,
                            borderRadius: "50%",
                        }} />
                        <label htmlFor="photo" style={{
                            backgroundColor: "white",
                            cursor: "pointer",
                            border: "1px solid #ccc",
                            borderRadius: 20,
                            padding: 10,
                            margin: 5,
                            fontSize: 12,
                            color: "black",
                            fontFamily: "Arial",
                        }}>
                            Cambiar foto
                        </label>
                        <input type="file" name="photo" id="photo" onChange={(e) => setPhoto(e.target.files[0])} style={{display: "none"}} />
                        <button type="submit" disabled={loading}
                            style={{
                                backgroundColor: "white",
                                cursor: "pointer",
                                border: "1px solid #ccc",
                                borderRadius: 20,
                                padding: 10,
                                margin: 5,
                                fontSize: 12,
                            }}
                        >Subir foto</button>
                        <button onClick={() => setEditPhoto(false)} disabled={loading}
                            style={{
                                backgroundColor: "white",
                                cursor: "pointer",
                                border: "1px solid #ccc",
                                borderRadius: 20,
                                padding: 10,
                                margin: 5,
                                fontSize: 12,
                            }}
                        >Cancelar</button>
                    </form>
                    </>
                    }
                </div>
            </div>
            <Vaccines vaccines={vaccines} pet={pet} userId={userId} setVaccines={setVaccines} />
            <VetHistory pet={pet} userId={userId} medicalHistory={medicalHistory} setMedicalHistory={setMedicalHistory} medicines={medicines} />
            </div>
            }
        </section>
    );
}

export default MascotaDetails;